import __vue_component__ from '../Spinner/Spinner.vue.js';
import Clear from '../Icon/EditorErrorIcon.js';
import Caret from '../Icon/HipchatChevronDownIcon.js';

//
var script = {
  name: 'Icons',
  components: {
    Spinner: __vue_component__,
    Caret,
    Clear
  },
  props: {
    isFetching: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    createable: {
      type: Boolean,
      default: false
    },
    isClearable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shouldShowClearIcon() {
      return this.isSelected && !this.isFetching && this.isClearable;
    }

  },
  methods: {
    onClear() {
      this.$emit('clear');
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/Icons.vue_rollup-plugin-vue=script.js